import styled from 'styled-components'
import Icon from '@hotmart/space-lib/dist/components/icon'
import { CustomInputRangeProps } from './audioPlayer.types'
import { CustomProgressInputRange } from './components/elapsedTime/elapsedTime.styles'

export const Dropdown = styled.div<{ $isDarkMode: boolean }>`
  z-index: 1;
  white-space: nowrap;
  background-color: ${({ $isDarkMode }) => ($isDarkMode ? 'var(--black)' : 'var(--white)')};
`

Dropdown.displayName = 'Dropdown'

export const SpeedButton = styled.button`
  font-size: 0.5rem;
  outline: 0 !important;
`

SpeedButton.displayName = 'SpeedButton'

export const CustomAudioWrapper = styled.div`
  width: min(100%, 21.313rem);
  border-radius: 6.25rem;
`

CustomAudioWrapper.displayName = 'CustomAudioWrapper'

export const WrapperCustomInputRange = styled.div`
  border-radius: 6.25rem;
`

WrapperCustomInputRange.displayName = 'WrapperCustomInputRange'

export const CustomInputRange = styled(CustomProgressInputRange)<CustomInputRangeProps>`
  transition: width 0.4s ease;
  width: ${({ expanded, isMobile }) => {
    const expandedSize = isMobile ? '2.813rem' : '3.75rem'

    return expanded ? expandedSize : '0'
  }};
`

CustomInputRange.displayName = 'CustomInputRange'

export const CustomIcon = styled(Icon)`
  width: 1.25rem;
`

CustomIcon.displayName = 'CustomIcon'

export const PlayPauseButton = styled.button`
  outline: 0 !important;
`

PlayPauseButton.displayName = 'PlayPauseButton'

export const VolumeButton = styled.button`
  outline: 0 !important;
`

VolumeButton.displayName = 'VolumeButton'

export const DeleteButton = styled.button`
  outline: 0 !important;
`

DeleteButton.displayName = 'DeleteButton'
